import { render, staticRenderFns } from "./SuggestionListe.vue?vue&type=template&id=3c3624f2&"
import script from "./SuggestionListe.vue?vue&type=script&lang=js&"
export * from "./SuggestionListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports